// Generated by `yarn tokens:import` from the Figma "spacing" variables export. Do not edit.

export const spacingModes = {
    'mode-1': 'Mode 1',
} as const

export const spacingTokens = {
    'large-layout/2xl': {
        alias: 'large-layout/2xl',
        type: 'dimension',
        id: 'VariableID:9080:47531',
        scopes: ['GAP'],
        value: 24,
    },
    'large-layout/3xl': {
        alias: 'large-layout/3xl',
        type: 'dimension',
        id: 'VariableID:9080:47532',
        scopes: ['GAP'],
        value: 32,
    },
    'large-layout/4xl': {
        alias: 'large-layout/4xl',
        type: 'dimension',
        id: 'VariableID:9080:47533',
        scopes: ['GAP'],
        value: 36,
    },
    'medium-less-dense/l': {
        alias: 'medium-less-dense/l',
        type: 'dimension',
        id: 'VariableID:9080:47529',
        scopes: ['GAP'],
        value: 16,
    },
    'medium-less-dense/m': {
        alias: 'medium-less-dense/m',
        type: 'dimension',
        id: 'VariableID:9080:47528',
        scopes: ['GAP'],
        value: 12,
    },
    'medium-less-dense/xl': {
        alias: 'medium-less-dense/xl',
        type: 'dimension',
        id: 'VariableID:9080:47530',
        scopes: ['GAP'],
        value: 20,
    },
    'small-compact/2xs': {
        alias: 'small-compact/2xs',
        type: 'dimension',
        id: 'VariableID:9080:45919',
        scopes: ['GAP'],
        value: 2,
    },
    'small-compact/3xs-seam': {
        alias: 'small-compact/3xs-seam',
        type: 'dimension',
        id: 'VariableID:16887:217523',
        desc: 'Space between 2 parts of one element. Example: DoubleButton - space between left and right part',
        value: 1,
    },
    'small-compact/s': {
        alias: 'small-compact/s',
        type: 'dimension',
        id: 'VariableID:9080:47513',
        scopes: ['GAP'],
        value: 8,
    },
    'small-compact/xs': {
        alias: 'small-compact/xs',
        type: 'dimension',
        id: 'VariableID:9080:47512',
        scopes: ['GAP'],
        value: 4,
    },
} as const
